import { STATIC_INBOXES_IDS } from '@/components/Inbox/inbox.const.js';

const isMobile = require('is-mobile');

import VueRouter from 'vue-router';

import InstallationSignup from '../views/InstallationSignup';
import InstallationLogin from '../views/InstallationLogin';
import MissingSettings from '../views/settings/MissingSettings';
import SettingsProfiles from '../views/settings/SettingsProfiles';

const SlackConnectionSettings = () => import('../views/settings/SettingsSlackConnection');

import { embeddedAppRoute } from './embedded-app-routes';
import { addRequiredAuth } from './helpers';
import Guards from './routerGuards';
import BlockEditorDispatcher from '../components/BlockEditor/BlockEditorDispatcher';
import TriggerEditor from '../components/BlockEditor/TriggerEditor';
import { propsValidator, extensionPropsValidator } from '../utils/helpers';
import AllProjects from '../views/AllProjects';
import AccountChangeRequired from '../views/AppContentPages/AccountChangeRequired.vue';
import Alerts from '../views/AppContentPages/Alerts';
import Analytics from '../views/AppContentPages/Analytics.vue';
import BuilderDebugMode from '../views/AppContentPages/BuilderDebugMode.vue';
import BuilderVersionHistory from '../views/AppContentPages/BuilderVersionHistory.vue';
import GettingStartedIntro from '../views/AppContentPages/GettingStartedIntro.vue';
import GettingStartedLandingPage from '../views/AppContentPages/GettingStartedLandingPage.vue';
import Inbox from '../views/AppContentPages/Inbox.vue';
import Issues from '../views/AppContentPages/Issues.vue';
import IssuesManagementTaskLog from '../views/AppContentPages/IssuesManagementTaskLog.vue';
import Learn from '../views/AppContentPages/Learn.vue';
import OnBoarding from '../views/AppContentPages/OnBoarding.vue';
import PlacementButtonsDropdownDataProvider from '../views/AppContentPages/PlacementButtonsDropdownDataProvider.vue';
import PlacementConnections from '../views/AppContentPages/PlacementConnections.vue';
import PlacementFeaturesDataProvider from '../views/AppContentPages/PlacementFeaturesDataProvider.vue';
import ProcessReports from '../views/AppContentPages/ProcessReports';
import Processes from '../views/AppContentPages/Processes';
import Settings from '../views/AppContentPages/Settings';
import SpaceButtonsDropdownDataProvider from '../views/AppContentPages/SpaceButtonsDropdownDataProvider.vue';
import SpaceConnections from '../views/AppContentPages/SpaceConnections.vue';
import SpaceFeaturesDataProvider from '../views/AppContentPages/SpaceFeaturesDataProvider.vue';
import TaskLog from '../views/AppContentPages/TaskLog';
import AppGateway from '../views/AppGateway';
import AppLayout from '../views/AppLayout/AppLayout';
import ExtensionAppLayout from '../views/AppLayout/ExtensionAppLayout';
import ConnectService from '../views/ConnectService';
import ExternalDialogPage from '../views/ExternalDialogPage/ExternalDialogPage';
import Forbidden from '../views/Forbidden';
import ForgotPassword from '../views/ForgotPassword';
import GoogleCallback from '../views/GoogleCallback';
import InstallChrome from '../views/InstallChrome';
import EditInstalledWorkflowConfiguration from '../views/Installables/EditInstalledWorkflowConfiguration';
import Installation from '../views/Installables/Installation';
import MobileInstallation from '../views/Installables/MobileInstallation';
import InstallationComplete from '../views/InstallationComplete';
import IntegrationConnected from '../views/IntegrationConnected';
import Login from '../views/Login';
import MobileNotSupported from '../views/MobileNotSupported';
import NewFlow from '../views/NewFlow';
import PlacementRoot from '../views/PlacementRoot';
import PlacementSectionRoot from '../views/PlacementSectionRoot';
import PreProfileConnect from '../views/PreProfileConnect/PreProfileConnect';
import PreProfileConnectCrisp from '../views/PreProfileConnect/PreProfileConnectCrisp';
import PreProfileConnectMonday from '../views/PreProfileConnect/PreProfileConnectMonday';
import PrivacySettingsPage from '../views/PrivacySettingsPage';
import Project from '../views/Project';
import Projects from '../views/Projects';
import ProjectsRoot from '../views/ProjectsRoot';
import ResetPassword from '../views/ResetPassword';
import SSOCallback from '../views/SSOCallback';
import Signup from '../views/Signup';
import SettingsCnames from '../views/settings/SettingsCnames';
import Groups from '../views/settings/SettingsGroups';
import ManageApps from '../views/settings/SettingsManageApps';
import SettingsManageCustomDomains from '../views/settings/SettingsManageCustomDomains';
import ManageUsers from '../views/settings/SettingsManageUsers';
import MySettings from '../views/settings/SettingsMySettings';
import SettingsOrganization from '../views/settings/SettingsOrganization';
import SettingsWorkspaceDomain from '../views/settings/SettingsWorkspaceDomains.vue';
import ManageGroups from '../views/settings/groups/ManageGroups';
import ManageSingleGroup from '../views/settings/groups/ManageSingleGroup';
import InstallExtensionLink from '../views/userRegistration/InstallExtensionLink';
import InvitedUserSignup from '../views/userRegistration/InvitedUserSignup';
import Logout from '../views/userRegistration/Logout';
import PinExtension from '../views/userRegistration/PinExtension';
import ResendVerificationEmail from '../views/userRegistration/ResendVerificationEmail';
import ResentVerificationEmailSuccessfully from '../views/userRegistration/ResentVerificationEmailSuccessfully';
import SetWorkspaceName from '../views/userRegistration/SetWorkspaceName';
import SignedUpSuccessfull from '../views/userRegistration/SignedUpSuccessfull';
import SlackWorkspaceSelector from '../views/userRegistration/SlackWorkspaceSelector.vue';
import TemporaryVerificationCode from '../views/userRegistration/TemporaryVerificationCode';
import TemporaryVerificationCodeInput from '../views/userRegistration/TemporaryVerificationCodeInput';
import UserDetailsForm from '../views/userRegistration/UserDetailsForm';
import WorkspaceSelector from '../views/userRegistration/WorkspaceSelector.vue';
import AnalyticsByDays from '@/components/Analytics/AnalyticsByDays.vue';
import AnalyticsByFeatures from '@/components/Analytics/AnalyticsByFeatures.vue';
import AnalyticsByUsers from '@/components/Analytics/AnalyticsByUsers.vue';
import AnalyticsDashboard from '@/components/Analytics/AnalyticsDashboard.vue';
import ConnectionFeatures from '@/components/ManageFeatures/Features/ConnectionFeatures.vue';
import ConnectionFeaturesHeader from '@/components/ManageFeatures/Features/ConnectionFeaturesHeader.vue';
import ProcessReportsInfo from '@/components/ProcessReports/ProcessReportsInfo';
import Process from '@/components/Processes/Process';
import TaskLogInfo from '@/components/TaskLog/TaskLogInfo';
import InAppAlertRun from '@/components/common/Alerts/InAppAlertRun.vue';
import NotificationsIntro from '@/components/common/Alerts/NotificationsIntro.vue';
import BillingUsageRouter from '@/router/BillingUsage/billing-usage-router';
import {
	EXTENSION_PREFIX,
	LEARN_ROUTE_NAME,
	INBOX_ROUTE_NAME,
	ISSUES_ROUTE_NAME,
	PROCESS_ROUTE_NAME,
	FEATURES_ROUTE_NAME,
	TASK_LOG_ROUTE_NAME,
	PLACEMENT_MODE_NAME,
	PROCESSES_ROUTE_NAME,
	ANALYTICS_ROUTE_NAME,
	CONNECTIONS_ROUTE_NAME,
	BLOCK_EDITOR_ROUTE_NAME,
	TASK_LOG_INFO_ROUTE_NAME,
	CUSTOMIZE_PLAN_ROUTE_NAME,
	TRIGGER_EDITOR_ROUTE_NAME,
	BUTTON_DROPDOWN_ROUTE_NAME,
	IN_APP_ALERT_RUN_ROUTE_NAME,
	PLACEMENT_ADD_ONS_MODE_NAME,
	BUILDER_TASK_LOG_ROUTE_NAME,
	BUILDER_TASK_LOG_INNER_PAGE,
	CREATE_AND_MANAGE_ROUTE_NAME,
	BUILDER_DEBUG_MODE_ROUTE_NAME,
	ANALYTICS_TOP_USERS_ROUTE_NAME,
	ANALYTICS_DASHBOARD_ROUTE_NAME,
	PLACEMENT_MODE_EVERYTHING_NAME,
	WORKSPACE_SELECTION_ROUTE_NAME,
	EDIT_BUTTON_DROPDOWN_ROUTE_NAME,
	PLACEMENT_FEATURE_TYPES_MODE_NAME,
	ANALYTICS_TOP_FEATURES_ROUTE_NAME,
	ACCOUNT_CHANGE_REQUIRED_ROUTE_NAME,
	ANALYTICS_USAGE_PER_DAY_ROUTE_NAME,
	BUILDER_VERSION_HISTORY_ROUTE_NAME,
	SLACK_WORKSPACE_SELECTION_ROUTE_NAME,
	ISSUES_MANAGEMENT_TASK_LOG_ROUTE_NAME,
} from '@/router/router.const.js';
import { ALL_PROJECTS_VIRTUAL_ID } from '@/utils/projects.const';
import EditButtonsDropdown from '@/views/AppContentPages/EditButtonsDropdown.vue';
import FlowDetails from '@/views/AppContentPages/FlowDetails.vue';
import CreateAndManageService from '@/views/AppLayout/ManageAndCreate/create-and-manage-service';
import ManageAndCreate from '@/views/AppLayout/ManageAndCreate.vue';
import ManageFeatures from '@/views/AppLayout/ManageFeatures.vue';
import Marketplace from '@/views/AppLayout/Marketplace.vue';
import BillingMainPage from '@/views/BillingMainPage.vue';
import ChangeWorkspaceOwnerConformation from '@/views/ChangeWorkspaceOwnerConformation';
import DeleteWorkspaceConformation from '@/views/DeleteWorkspaceConformation';
import ExtensionCreationWizard from '@/views/ExtensionPages/ExtensionCreationWizard.vue';
import ExtensionEditInstalledWorkflowConfiguration from '@/views/ExtensionPages/ExtensionEditInstalledWorkflowConfiguration.vue';
import ExtensionPublishWorkflow from '@/views/ExtensionPages/ExtensionPublishWorkflow.vue';
import ExtensionRunFlowRestricted from '@/views/ExtensionRunFlowRestricted.vue';
import BuilderTaskLog from '@/views/Flow/BuilderTaskLog.vue';
import BuilderTaskLogInnerPage from '@/views/Flow/BuilderTaskLogInnerPage.vue';
import EditButtonsDropdownHeader from '@/views/Flow/EditButtonsDropdownHeader.vue';
import FlowDetailsHeader from '@/views/Flow/FlowDetailsHeader.vue';
import FlowRouter from '@/views/Flow/FlowRouter.vue';
import Fonts from '@/views/Fonts.vue';
import InterfacesLogs from '@/views/InterfacesLogs.vue';
import ShareWorkflow from '@/views/ShareWorkflow.vue';
import PendingInstallationSignup from '@/views/userRegistration/PendingInstallationSignup.vue';

/* Analytics */
const getAnalyticsChildren = (prefix = '') => [
	{
		path: '',
		component: AnalyticsDashboard,
		name: `${prefix}${ANALYTICS_DASHBOARD_ROUTE_NAME}`,
		props: (route) => propsValidator(route, AnalyticsDashboard),
	},
	{
		path: 'users',
		component: AnalyticsByUsers,
		meta: { title: 'Breakdown by users' },
		name: `${prefix}${ANALYTICS_TOP_USERS_ROUTE_NAME}`,
		props: (route) => propsValidator(route, AnalyticsByUsers),
	},
	{
		path: 'features',
		component: AnalyticsByFeatures,
		meta: { title: 'Breakdown by features' },
		name: `${prefix}${ANALYTICS_TOP_FEATURES_ROUTE_NAME}`,
		props: (route) => propsValidator(route, AnalyticsByFeatures),
	},
	{
		path: 'days',
		component: AnalyticsByDays,
		meta: { title: 'Breakdown by days' },
		name: `${prefix}${ANALYTICS_USAGE_PER_DAY_ROUTE_NAME}`,
		props: (route) => propsValidator(route, AnalyticsByDays),
	},
];
const getAnalyticsRootRedirect = (prefix = '') => ({ name: `${prefix}${ANALYTICS_DASHBOARD_ROUTE_NAME}` });
/* Analytics */

/* Right side drawer */
const getRightSideDrawerChildren = (prefix = '') => [
	{
		path: 'nodes/:nodeID',
		component: BlockEditorDispatcher,
		name: `${prefix}${BLOCK_EDITOR_ROUTE_NAME}`,
		props(route) {
			return propsValidator(route, BlockEditorDispatcher);
		},
	},
	{
		path: 'trigger',
		component: TriggerEditor,
		name: `${prefix}${TRIGGER_EDITOR_ROUTE_NAME}`,
		props(route) {
			return propsValidator(route, TriggerEditor);
		},
	},
];
/* Right side drawer */

const ExtensionRoutes = {
	path: '/extension',
	component: ExtensionAppLayout,
	children: [
		{
			path: 'share-workflow/:workflowId',
			name: `${EXTENSION_PREFIX}ShareWorkflow`,
			component: ShareWorkflow,
			props: (route) => extensionPropsValidator(route, ShareWorkflow),
			meta: {
				dontNotifyExtensionOnCreated: true, // dont notify extension on created (happens in ExtensionAppLayout) => we will notify it manually, after the dialog is opened
			},
		},
		{
			path: 'run-workflow-restricted/:mode/:hashId?',
			name: `${EXTENSION_PREFIX}RunWorkflowRestricted`,
			component: ExtensionRunFlowRestricted,
			props: (route) => extensionPropsValidator(route, ExtensionRunFlowRestricted),
			meta: {
				noContentPadding: true,
				dontNotifyExtensionOnCreated: true, // dont notify extension on created (happens in ExtensionAppLayout) => we will notify it manually, after the dialog is opened
			},
		},
		{
			path: 'publish-workflow/:workflowId',
			name: `${EXTENSION_PREFIX}PublishWorkflow`,
			component: ExtensionPublishWorkflow,
			props: (route) => extensionPropsValidator(route, ExtensionPublishWorkflow),
			meta: {
				noContentPadding: true,
				dontNotifyExtensionOnCreated: true, // dont notify extension on created (happens in ExtensionAppLayout) => we will notify it manually, after the dialog is opened
			},
		},
		{
			path: 'feature-details/:wfID',
			name: `${EXTENSION_PREFIX}FlowDetails`,
			component: FlowDetails,
			props: (route) => extensionPropsValidator(route, FlowDetails),
			meta: {
				headerComponent: FlowDetailsHeader,
				headerComponentProps: (route) => extensionPropsValidator(route, FlowDetailsHeader),
			},
		},
		/* 
		BACKWARDS COMPATIBILITY
		*/
		{
			path: 'flow-details/:wfID',
			redirect: { name: `${EXTENSION_PREFIX}FlowDetails` },
		},
		/* 
		BACKWARDS COMPATIBILITY
		*/
		{
			path: 'creation-wizard/:featureTypeId',
			name: `${EXTENSION_PREFIX}CreationWizard`,
			component: ExtensionCreationWizard,
			props: (route) => extensionPropsValidator(route, ExtensionCreationWizard),
		},
		{
			path: 'edit-workflow-configuration/:workflowId/',
			name: `${EXTENSION_PREFIX}editWorkflowConfiguration`,
			component: ExtensionEditInstalledWorkflowConfiguration,
			props: (route) => extensionPropsValidator(route, ExtensionEditInstalledWorkflowConfiguration),
			meta: { title: 'Configuration', noContentPadding: true },
		},
		{
			meta: { noContentPadding: true },
			path: 'workspaces',
			component: WorkspaceSelector,
			name: `${EXTENSION_PREFIX}${WORKSPACE_SELECTION_ROUTE_NAME}`,
			props: (route) => extensionPropsValidator(route, WorkspaceSelector),
		},
		{
			path: '',
			component: ManageFeatures,
			children: [
				{
					path: 'connection/:serviceID/:serviceWorkspaceID',
					name: `${EXTENSION_PREFIX}ConnectionFeatures`,
					component: ConnectionFeatures,
					props: (route) =>
						extensionPropsValidator(route, ConnectionFeatures, {
							serviceWorkspaceID: CreateAndManageService.convertServiceWorkspaceIdToInternalValue(route.params.serviceWorkspaceID),
							//DISPLAY ONLY -REVERT readable url and text to the user - to its previous real one
						}),
					meta: {
						headerComponent: ConnectionFeaturesHeader,
						headerComponentProps: (route) => extensionPropsValidator(route, ConnectionFeaturesHeader),
					},
				},
			],
		},
	],
};

const allowedWithoutAuthRoutes = [
	{
		path: '/run/:hashId/:extraId?',
		name: 'FlowRunLegacy', // this route exists only for redirecting.
		beforeEnter(to) {
			const { VUE_APP_RUN_FLOW_BASE } = process.env;
			if (VUE_APP_RUN_FLOW_BASE && to?.fullPath) {
				const targetUrl = new URL(to.fullPath, VUE_APP_RUN_FLOW_BASE);
				// don't cause redirect loop
				if (window.location.host != targetUrl.host) {
					window.location.href = targetUrl;
				}
			}
		},
	},
	{
		path: '/mobile-not-supported',
		name: 'MobileNotSupported',
		component: MobileNotSupported,
	},
	{
		path: '/signup',
		name: 'Signup',
		component: Signup,
		props: (route) => ({ ...route.params, prefilledEmail: route.query.user_email, uid: route.query.uid || null }),
	},
	{
		path: '/pending-installation-signup/:installableId',
		name: 'PendingInstallationSignup',
		component: PendingInstallationSignup,
		props: (route) => ({ ...route.params }),
	},

	{
		path: '/invited-user-signup',
		name: 'InvitedUserSignup',
		component: InvitedUserSignup,
		props: (route) => ({ ...route.params, prefilledEmail: route.query.user_email, uid: route.query.uid || null }),
	},
	{
		path: '/workspaces',
		component: WorkspaceSelector,
		name: WORKSPACE_SELECTION_ROUTE_NAME,
		props: (route) => propsValidator(route, WorkspaceSelector),
	},
	{
		path: '/signed-up-successfull',
		name: 'SignedUpSuccessfull',
		component: SignedUpSuccessfull,
		props: (route) => ({ ...route.params, ...{ userEmail: route.query.userEmail } }),
	},
	{
		path: '/resend-verification-email',
		name: 'ResendVerificationEmail',
		component: ResendVerificationEmail,
		props: (route) => ({ ...route.params, ...{ userEmail: route.query.userEmail } }),
	},
	{
		path: '/resent-verification-email-successfully',
		name: 'ResentVerificationEmailSuccessfully',
		component: ResentVerificationEmailSuccessfully,
		props: (route) => ({ ...route.params, ...{ userEmail: route.query.userEmail } }),
	},
	{
		path: '/forbidden',
		name: 'Forbidden',
		component: Forbidden,
	},
	{
		path: '/login',
		name: 'Login',
		component: Login,
		props: (route) => ({
			token: route.query.token,
		}),
	},
	{
		path: '/forgot',
		name: 'Forgot',
		component: ForgotPassword,
		props: true,
	},
	{
		path: '/reset',
		name: 'Reset',
		component: ResetPassword,
		props: (route) => {
			const userID = Number.parseInt(route.query.uid, 10);
			if (Number.isNaN(userID)) {
				return 0;
			}
			return { token: route.query.t, userID };
		},
	},
	{
		path: '/temporary-verification-code-input',
		name: 'TemporaryVerificationCodeInput',
		component: TemporaryVerificationCodeInput,
	},
	{
		path: '/googleCallback',
		name: 'GoogleCallback',
		component: GoogleCallback,
		props: (route) => ({ ...route.query }),
	},
	{
		path: '/ssoCallback',
		name: 'SSOCallback',
		component: SSOCallback,
		props: (route) => ({ ...route.query }),
	},
	{
		path: '/troubleshoot-privacy',
		name: 'PrivacySettingsPage',
		component: PrivacySettingsPage,
	},
	{
		path: '/user-details-form',
		name: 'UserDetailsForm',
		component: UserDetailsForm,
		props: (route) => ({ ...route.query }),
	},
	{
		path: '/installation-signup',
		name: 'InstallationSignup',
		component: InstallationSignup,
		props: (route) => ({ ...route.query }),
	},
	{
		path: '/installation-login',
		name: 'InstallationLogin',
		component: InstallationLogin,
		props: (route) => ({ ...route.query }),
	},
	{
		path: '/user-details-form',
		name: 'InstallationUserDetailsForm',
		component: UserDetailsForm,
		props: (route) =>
			// return { ...route.query, ...route.params };
			propsValidator(route, UserDetailsForm),
	},
	{
		path: '/googleCallback',
		name: 'InstallationGoogleCallback',
		component: GoogleCallback,
		props: (route) => ({ ...route.query }),
	},
	{
		path: '/forgot',
		name: 'InstallationForgot',
		component: ForgotPassword,
		props: true,
	},
	{
		path: '/workspaces',
		component: WorkspaceSelector,
		name: `Installation${WORKSPACE_SELECTION_ROUTE_NAME}`,
		props: (route) => propsValidator(route, WorkspaceSelector),
	},
	{
		path: '/signed-up-successfull',
		name: 'InstallationSignedUpSuccessfull',
		component: SignedUpSuccessfull,
		props: (route) => ({ ...route.params, ...{ userEmail: route.query.userEmail } }),
	},
	{
		path: '/resend-verification-email',
		name: 'InstallationResendVerificationEmail',
		component: ResendVerificationEmail,
		props: (route) => ({ ...route.params, ...{ userEmail: route.query.userEmail } }),
	},
	{
		path: '/resent-verification-email-successfully',
		name: 'InstallationResentVerificationEmailSuccessfully',
		component: ResentVerificationEmailSuccessfully,
		props: (route) => ({ ...route.params, ...{ userEmail: route.query.userEmail } }),
	},

	{
		path: '/installation-complete',
		name: 'InstallationComplete',
		component: InstallationComplete,
		props: (route) => propsValidator(route, InstallationComplete),
	},
	{
		path: '/mobile-not-supported',
		name: 'InstallationMobileNotSupported',
		component: MobileNotSupported,
	},
	{
		path: '/mobile-installation/:installableId/',
		name: 'MobileInstallation',
		component: MobileInstallation,
		props(route) {
			return propsValidator(route, MobileInstallation);
		},
	},
	{
		path: '/install-extension-link',
		name: 'InstallationInstallExtensionLink',
		component: InstallExtensionLink,
	},
	{
		path: '/install-chrome',
		name: 'InstallationInstallChrome',
		component: InstallChrome,
	},
	{
		path: '/installation/:installableId/',
		name: 'Installation',
		component: Installation,
		props(route) {
			return propsValidator(route, Installation);
		},
	},
	{
		path: '/install-extension-link',
		name: 'InstallExtensionLink',
		component: InstallExtensionLink,
	},
	{
		path: '/pin-extension',
		name: 'InstallationPinExtension',
		component: PinExtension,
	},
	{
		path: '/install-chrome',
		name: 'InstallChrome',
		component: InstallChrome,
	},
	{
		path: '/pin-extension',
		name: 'PinExtension',
		component: PinExtension,
	},
	{
		path: '/logout',
		name: 'logout',
		component: Logout,
	},
];

const requiredAuthRoutes = [
	embeddedAppRoute,
	ExtensionRoutes,
	{
		path: '/customize-plan',
		component: BillingMainPage,
		name: CUSTOMIZE_PLAN_ROUTE_NAME,
		props: (route) => propsValidator(route, BillingMainPage),
	},
	{
		path: '/slack-workspace-selector',
		component: SlackWorkspaceSelector,
		name: SLACK_WORKSPACE_SELECTION_ROUTE_NAME,
		props(route) {
			return propsValidator(route, SlackWorkspaceSelector);
		},
	},
	{
		path: '/fonts',
		name: 'fontsRouteName',
		component: Fonts,
	},
	{
		path: '/edit-workflow-configuration/:workflowId/',
		name: 'editWorkflowConfiguration',
		component: EditInstalledWorkflowConfiguration,
		meta: { title: 'Configuration' },
		props(route) {
			return propsValidator(route, EditInstalledWorkflowConfiguration);
		},
	},
	{
		path: '',
		redirect: { name: 'HomePage' },
	},
	{
		// backward compatibility
		path: '/modules',
		redirect: { name: FEATURES_ROUTE_NAME },
	},
	/* 
		BACKWARDS COMPATIBILITY
	*/
	{ path: '/project/*', redirect: (to) => ({ path: to.path.replace('project', 'space').replace('features', 'feature') }) },
	/* 
		BACKWARDS COMPATIBILITY
	*/
	{
		path: '/space/:pID',
		name: 'Project',
		component: Project,
		props(route) {
			return propsValidator(route, Project);
		},
		children: [
			{
				// backward compatibility
				path: 'flow/:wfID',
				redirect: { name: 'Feature' },
			},
			{
				path: 'feature/new',
				name: 'NewFeature',
				component: NewFlow,
				props: true,
				beforeEnter: Guards.guardCreateWorkflowInProject,
			},
			{
				path: 'feature/:wfID',
				name: 'Feature',
				component: FlowRouter,
				beforeEnter: Guards.guardEditWorkflowPermissions,
				props: (route) => ({ wfID: parseInt(route.params.wfID) }),
				children: [
					// Right side drawer
					...getRightSideDrawerChildren(),
					// Left side drawer
					{
						path: 'task-log',
						name: BUILDER_DEBUG_MODE_ROUTE_NAME,
						components: { 'task-log': BuilderDebugMode },
						redirect: { name: BUILDER_TASK_LOG_ROUTE_NAME },
						props: (route) => propsValidator(route, BuilderDebugMode),
						children: [
							{
								path: '',
								name: BUILDER_TASK_LOG_ROUTE_NAME,
								component: BuilderTaskLog,
								props: (route) => propsValidator(route, BuilderTaskLog),
							},
							{
								path: ':taskLogId',
								name: BUILDER_TASK_LOG_INNER_PAGE,
								component: BuilderTaskLogInnerPage,
								props: (route) => propsValidator(route, BuilderTaskLogInnerPage),
								children: getRightSideDrawerChildren(BUILDER_TASK_LOG_INNER_PAGE),
							},
						],
					},
					{
						path: 'version/:versionId',
						name: BUILDER_VERSION_HISTORY_ROUTE_NAME,
						components: { version: BuilderVersionHistory },
						props: (route) => propsValidator(route, BuilderVersionHistory),
						children: getRightSideDrawerChildren(BUILDER_VERSION_HISTORY_ROUTE_NAME),
					},
				],
			},
			{
				path: 'flow/:wfID/external-dialog',
				name: 'Flow',
				component: ExternalDialogPage,
				beforeEnter: Guards.guardEditWorkflowPermissions,
				props(route) {
					return propsValidator(route, FlowRouter);
				},
			},
		],
	},
	{
		path: '/',
		component: AppLayout,
		children: [
			{ path: '', redirect: { name: 'HomePage' } },
			{
				component: AccountChangeRequired,
				path: 'account-change-required',
				meta: { noContentPadding: true },
				name: ACCOUNT_CHANGE_REQUIRED_ROUTE_NAME,
				props: (route) => propsValidator(route, AccountChangeRequired),
			},
			{
				path: 'notification-redirect/:inboxId/:alertId',
				redirect: (to) => ({
					name: IN_APP_ALERT_RUN_ROUTE_NAME,
					params: { alertId: Number(to.params.alertId), inboxId: to.params.inboxId, stickToTop: true },
				}),
			},
			// notification-redirect is the engine's way to redirect to a specific alert in a specific inbox
			// (we did it like that so it won't break if we change the route path in the future)
			{
				path: 'notification-redirect/:alertId',
				redirect: (to) => ({
					name: IN_APP_ALERT_RUN_ROUTE_NAME,
					params: { alertId: Number(to.params.alertId), inboxId: STATIC_INBOXES_IDS.PRIVATE_INBOX_ID, stickToTop: true }, // if an inbox id was not provided, we assume it's the private inbox
				}),
			},
			{
				component: Inbox,
				path: 'inbox/:inboxId',
				meta: { noContentPadding: true },
				props: (route) => propsValidator(route, Inbox),
				children: [
					{ path: '', name: INBOX_ROUTE_NAME, component: NotificationsIntro },
					{
						path: ':alertId',
						component: InAppAlertRun,
						name: IN_APP_ALERT_RUN_ROUTE_NAME,
						props: (route) => propsValidator(route, InAppAlertRun),
					},
				],
			},
			{
				path: 'learn',
				component: Learn,
				name: LEARN_ROUTE_NAME,
				meta: {
					noContentPadding: true,
				},
			},
			{
				path: 'on-boarding',
				name: 'OnBoarding',
				component: OnBoarding,
				meta: {
					noContentPadding: true,
				},
			},
			BillingUsageRouter,
			{
				path: 'getting-started',
				name: 'GettingStartedIntro',
				component: GettingStartedIntro,
				props: (route) => propsValidator(route, GettingStartedIntro),
				meta: {
					noContentPadding: true,
				},
			},
			{
				path: 'getting-started/:featureType',
				name: 'GettingStartedLandingPage',
				component: GettingStartedLandingPage,
				props: (route) => propsValidator(route, GettingStartedLandingPage),
				meta: {
					noContentPadding: true,
				},
			},
			{
				path: 'marketplace',
				name: 'Marketplace',
				component: Marketplace,
				meta: {
					noContentPadding: true,
				},
			},
			{
				path: '/my-input-logs/:taskLogId/',
				name: 'InterfacesLogs',
				component: InterfacesLogs,
				meta: {
					noContentPadding: true,
				},
				props(route) {
					return propsValidator(route, InterfacesLogs);
				},
			},
			{
				path: 'home',
				name: 'HomePage',
				redirect: { name: 'GettingStartedIntro' },
				// component: HomePage,
			},
			/* 
				BACKWARDS COMPATIBILITY
			*/
			{
				path: 'features',
				redirect: { name: 'ProjectsRoot' },
			},
			/* 
				BACKWARDS COMPATIBILITY
			*/
			{
				path: 'manage',
				component: ManageAndCreate,
				name: CREATE_AND_MANAGE_ROUTE_NAME,
				redirect: { name: PLACEMENT_MODE_NAME },
				beforeEnter: Guards.guardCreateAndManage,
				props(route) {
					return propsValidator(route, ManageAndCreate, {
						serviceWorkspaceId: CreateAndManageService.convertServiceWorkspaceIdToInternalValue(route.params.serviceWorkspaceId), //DISPLAY ONLY -REVERT readable url and text to the user - to its previous real one
					});
				},
				meta: {
					noContentPadding: true,
				},
				children: [
					{ path: '', redirect: { name: PLACEMENT_MODE_NAME } },
					/* 
						BACKWARDS COMPATIBILITY
					*/
					{ path: 'projects/*', redirect: (to) => ({ path: to.path.replace('projects', 'space') }) },
					/* 
						BACKWARDS COMPATIBILITY
					*/
					{
						path: 'space',
						name: 'ProjectsRoot',
						component: ProjectsRoot,
						redirect: { name: FEATURES_ROUTE_NAME, params: { pID: ALL_PROJECTS_VIRTUAL_ID } },
						children: [
							{
								path: '',
								name: 'ProjectsHome',
								component: AllProjects,
								meta: {
									isProjectsHome: true,
								},
							},
							{
								path: ':pID',
								name: 'Projects',
								component: Projects,
								props(route) {
									return propsValidator(route, Projects);
								},
								children: [
									{
										path: 'features',
										name: FEATURES_ROUTE_NAME,
										component: SpaceFeaturesDataProvider,
										props(route) {
											return propsValidator(route, SpaceFeaturesDataProvider, {
												page: route.query.p,
												idsToShow: route.params.filter || [],
											});
										},
									},
									{
										path: 'connections',
										name: CONNECTIONS_ROUTE_NAME,
										component: SpaceConnections,
									},
									{
										path: 'analytics',
										component: Analytics,
										name: ANALYTICS_ROUTE_NAME,
										children: getAnalyticsChildren(),
										meta: { noContentPadding: true },
										redirect: getAnalyticsRootRedirect(),
										props: (route) => propsValidator(route, Analytics),
									},
									{
										path: 'issues',
										component: Issues,
										name: ISSUES_ROUTE_NAME,
										props: (route) => propsValidator(route, Issues),
									},
									{
										component: IssuesManagementTaskLog,
										path: 'issues/task-log/:workflowId/:issueId',
										name: `${ISSUES_MANAGEMENT_TASK_LOG_ROUTE_NAME}`,
										props: (route) => propsValidator(route, IssuesManagementTaskLog),
										meta: { title: 'Task log', sub: 'Task log' },
										children: [
											{
												props: true,
												component: TaskLogInfo,
												path: 'flow-run/:flowRunId',
												meta: { title: 'Task log', sub: 'Task Log' },
												name: `${ISSUES_MANAGEMENT_TASK_LOG_ROUTE_NAME}${TASK_LOG_INFO_ROUTE_NAME}`,
											},
										],
									},
									{
										path: 'button-dropdowns',
										name: BUTTON_DROPDOWN_ROUTE_NAME,
										component: SpaceButtonsDropdownDataProvider,
										props(route) {
											return propsValidator(route, SpaceButtonsDropdownDataProvider, {
												page: route.query.p,
												idsToShow: route.params.filter || [],
											});
										},
									},
									{
										path: 'processes',
										name: PROCESSES_ROUTE_NAME,
										meta: { title: 'Processes', sub: 'Processes' },
										component: Processes,
										children: [
											{
												path: ':processId',
												name: PROCESS_ROUTE_NAME,
												component: Process,
												props: true,
												meta: { title: 'Process', sub: 'Process' },
											},
										],
									},
									{
										path: 'process-reports',
										name: 'ProcessReports',
										meta: { title: 'Process reports', sub: 'Process reports' },
										component: ProcessReports,
										children: [
											{
												path: 'process/:processId',
												name: 'ProcessReportsInfo',
												component: ProcessReportsInfo,
												props: true,
												meta: { title: 'Process reports', sub: 'Process reports' },
											},
										],
									},
									{
										path: 'task-log',
										name: TASK_LOG_ROUTE_NAME,
										meta: {
											title: 'Task log',
											sub: 'Task log',
										},
										component: TaskLog,
										children: [
											{
												path: 'flow-run/:flowRunId',
												name: TASK_LOG_INFO_ROUTE_NAME,
												component: TaskLogInfo,
												props: true,
												meta: {
													title: 'Task log',
													sub: 'Task Log',
												},
											},
										],
									},
								],
							},
						],
					},
					{
						path: 'placement',
						component: PlacementRoot,
						name: PLACEMENT_MODE_NAME,
						redirect: { name: PLACEMENT_MODE_EVERYTHING_NAME },
						children: [
							{
								path: 'everything',
								component: PlacementSectionRoot,
								name: PLACEMENT_MODE_EVERYTHING_NAME,
								redirect: { name: PLACEMENT_MODE_EVERYTHING_NAME + FEATURES_ROUTE_NAME },
								children: [
									{
										path: 'features',
										name: PLACEMENT_MODE_EVERYTHING_NAME + FEATURES_ROUTE_NAME,
										component: PlacementFeaturesDataProvider,
										props(route) {
											return propsValidator(route, PlacementFeaturesDataProvider, {
												page: route.query.p,
												idsToShow: route.params.filter || [],
											});
										},
									},
									{
										path: 'connections',
										name: PLACEMENT_MODE_EVERYTHING_NAME + CONNECTIONS_ROUTE_NAME,
										component: PlacementConnections,
									},
									{
										path: 'button-dropdowns',
										component: PlacementButtonsDropdownDataProvider,
										name: PLACEMENT_MODE_EVERYTHING_NAME + BUTTON_DROPDOWN_ROUTE_NAME,
										props(route) {
											return propsValidator(route, PlacementButtonsDropdownDataProvider, {
												page: route.query.p,
												idsToShow: route.params.filter || [],
											});
										},
									},
									{
										path: 'analytics',
										component: Analytics,
										meta: { noContentPadding: true },
										props: (route) => propsValidator(route, Analytics),
										name: PLACEMENT_MODE_EVERYTHING_NAME + ANALYTICS_ROUTE_NAME,
										children: getAnalyticsChildren(PLACEMENT_MODE_EVERYTHING_NAME),
										redirect: getAnalyticsRootRedirect(PLACEMENT_MODE_EVERYTHING_NAME),
									},
									{
										path: 'issues',
										component: Issues,
										props: (route) => propsValidator(route, Issues),
										name: PLACEMENT_MODE_EVERYTHING_NAME + ISSUES_ROUTE_NAME,
									},
									{
										component: IssuesManagementTaskLog,
										path: 'issues/task-log/:workflowId/:issueId',
										props: (route) => propsValidator(route, IssuesManagementTaskLog),
										name: `${PLACEMENT_MODE_EVERYTHING_NAME}${ISSUES_MANAGEMENT_TASK_LOG_ROUTE_NAME}`,
										meta: { title: 'Task log', sub: 'Task log' },
										children: [
											{
												props: true,
												component: TaskLogInfo,
												path: 'flow-run/:flowRunId',
												meta: { title: 'Task log', sub: 'Task Log' },
												name: `${PLACEMENT_MODE_EVERYTHING_NAME}${ISSUES_MANAGEMENT_TASK_LOG_ROUTE_NAME}${TASK_LOG_INFO_ROUTE_NAME}`,
											},
										],
									},
									{
										path: 'task-log',
										component: TaskLog,
										name: PLACEMENT_MODE_EVERYTHING_NAME + TASK_LOG_ROUTE_NAME,
										meta: {
											title: 'Task log',
											sub: 'Task log',
										},
										children: [
											{
												path: 'flow-run/:flowRunId',
												name: PLACEMENT_MODE_EVERYTHING_NAME + TASK_LOG_INFO_ROUTE_NAME,
												component: TaskLogInfo,
												props: true,
												meta: {
													title: 'Task log',
													sub: 'Task Log',
												},
											},
										],
									},
								],
							},
							{
								path: ':featureType',
								name: PLACEMENT_FEATURE_TYPES_MODE_NAME,
								component: PlacementSectionRoot,
								redirect: { name: PLACEMENT_FEATURE_TYPES_MODE_NAME + FEATURES_ROUTE_NAME },
								children: [
									{
										path: 'features',
										name: PLACEMENT_FEATURE_TYPES_MODE_NAME + FEATURES_ROUTE_NAME,
										component: PlacementFeaturesDataProvider,
										props(route) {
											return propsValidator(route, PlacementFeaturesDataProvider, {
												page: route.query.p,
												idsToShow: route.params.filter || [],
												featureType: route.params.featureType,
											});
										},
									},
								],
							},
							{
								path: ':serviceSlug/:serviceWorkspaceId',
								name: PLACEMENT_ADD_ONS_MODE_NAME,
								component: PlacementSectionRoot,
								redirect: { name: PLACEMENT_ADD_ONS_MODE_NAME + FEATURES_ROUTE_NAME },
								children: [
									{
										path: 'features',
										name: PLACEMENT_ADD_ONS_MODE_NAME + FEATURES_ROUTE_NAME,
										component: PlacementFeaturesDataProvider,
										props(route) {
											return propsValidator(route, PlacementFeaturesDataProvider, {
												page: route.query.p,
												idsToShow: route.params.filter || [],
												serviceSlug: route.params.serviceSlug,
												serviceWorkspaceId: CreateAndManageService.convertServiceWorkspaceIdToInternalValue(
													route.params.serviceWorkspaceId
												),
												//DISPLAY ONLY -REVERT readable url and text to the user - to its previous real one
											});
										},
									},
									{
										path: 'connections',
										name: PLACEMENT_ADD_ONS_MODE_NAME + CONNECTIONS_ROUTE_NAME,
										component: PlacementConnections,
										props(route) {
											return propsValidator(route, PlacementConnections, {
												serviceSlug: route.params.serviceSlug,
												serviceWorkspaceId: CreateAndManageService.convertServiceWorkspaceIdToInternalValue(
													route.params.serviceWorkspaceId
												),
												//DISPLAY ONLY -REVERT readable url and text to the user - to its previous real one
											});
										},
									},
									{
										path: 'button-dropdowns',
										component: PlacementButtonsDropdownDataProvider,
										name: PLACEMENT_ADD_ONS_MODE_NAME + BUTTON_DROPDOWN_ROUTE_NAME,
										props(route) {
											return propsValidator(route, PlacementButtonsDropdownDataProvider, {
												page: route.query.p,
												idsToShow: route.params.filter || [],
												serviceSlug: route.params.serviceSlug,
												serviceWorkspaceId: CreateAndManageService.convertServiceWorkspaceIdToInternalValue(
													route.params.serviceWorkspaceId
												),
												//DISPLAY ONLY -REVERT readable url and text to the user - to its previous real one
											});
										},
									},
								],
							},
						],
					},
				],
			},
			{
				path: '/help',
				name: 'Help',
				component: MissingSettings,
			},
			{
				path: '/shortcuts',
				name: 'Shortcuts',
				component: MissingSettings,
			},
			{
				path: '/tables',
				name: 'Tables',
				component: MissingSettings,
			},
			{
				path: '/set-workspace-name',
				name: 'SetWorkspaceName',
				component: SetWorkspaceName,
			},
			{
				path: '/feature-details/:wfID',
				name: 'FlowDetails',
				component: FlowDetails,
				props: (route) => propsValidator(route, FlowDetails),
				meta: {
					headerComponent: FlowDetailsHeader,
					headerComponentProps: (route) => propsValidator(route, FlowDetailsHeader),
				},
			},
			{
				path: '/button-dropdown/:id',
				name: EDIT_BUTTON_DROPDOWN_ROUTE_NAME,
				component: EditButtonsDropdown,
				props: (route) => propsValidator(route, EditButtonsDropdown),
				meta: {
					headerComponent: EditButtonsDropdownHeader,
				},
			},
			{
				path: '/slack-connection',
				name: 'SlackConnection',
				component: SlackConnectionSettings,
			},
			/* 
				BACKWARDS COMPATIBILITY
			*/
			{
				path: 'flow-details/:wfID',
				redirect: { name: 'FlowDetails' },
			},
			/* 
				BACKWARDS COMPATIBILITY
			*/
			{
				path: 'settings',
				component: Settings,
				children: [
					{
						path: '',
						name: 'SettingsMe',
						component: MySettings,
						meta: {
							icon: 'my-settings',
							title: 'My Settings',
						},
					},
					{
						path: 'manage-apps',
						name: 'ManageApps',
						component: ManageApps,
						meta: {
							title: 'Manage Apps',
							icon: 'manage-apps-settings',
						},
					},
					{
						path: 'notifications',
						name: 'SettingsNotifications',
						component: MissingSettings,
					},
					{
						path: 'referrals',
						name: 'SettingsReferrals',
						component: MissingSettings,
					},
					{
						path: 'devices',
						name: 'SettingsDevices',
						component: MissingSettings,
					},
					{
						path: 'profiles',
						name: 'SettingsProfiles',
						component: SettingsProfiles,
						meta: {
							title: 'Profiles',
						},
					},
					{
						path: 'organization',
						name: 'SettingsOrganization',
						component: SettingsOrganization,
						meta: {
							icon: 'settings',
							title: 'Workspace Settings',
						},
					},
					{
						path: 'email-domains',
						name: 'AccountEmailDomains',
						component: SettingsWorkspaceDomain,
					},
					{
						path: 'custom-domains',
						name: 'SettingsCustomDomains',
						component: SettingsManageCustomDomains,
					},
					{
						path: 'cnames',
						name: 'SettingsCnames',
						component: SettingsCnames,
						meta: {
							title: 'Cnames',
						},
					},
					{
						path: 'organization/config',
						name: 'SettingsConfig',
						component: MissingSettings,
					},
					{
						path: 'organization/users',
						name: 'SettingsManageUsers',
						component: ManageUsers,
						meta: {
							icon: 'manage-users',
							title: 'Manage workspace members',
						},
					},
					{
						path: 'organization/groups',
						component: Groups,
						beforeEnter: Guards.guardIfCanManageGroups,
						meta: {
							title: 'Groups',
						},
						children: [
							{
								path: '',
								name: 'ManageGroups',
								component: ManageGroups,
								meta: {
									title: 'Groups',
									icon: 'manage-groups',
								},
							},
							{
								path: ':groupId',
								props(route) {
									return propsValidator(route, ManageSingleGroup);
								},
								name: 'ManageSingleGroup',
								component: ManageSingleGroup,
								meta: {
									title: 'Group',
								},
							},
						],
					},
					{
						path: 'organization/billing',
						name: 'SettingsPlanBilling',
						component: MissingSettings,
					},
					{
						path: 'organization/security',
						name: 'SettingsSecurity',
						component: MissingSettings,
					},
					{
						path: 'organization/apps',
						name: 'SettingsAllowedApps',
						component: MissingSettings,
					},
				],
				props(route) {
					return propsValidator(route, Projects);
				},
			},
			{
				path: '/alerts',
				name: 'Alerts',
				meta: { title: 'Alerts' },
				component: Alerts,
			},
		],
	},
	{
		path: '/connections/:serviceSlug/:standalone?',
		name: 'ConnectService',
		component: ConnectService,
		props: (route) => ({
			serviceSlug: route.params.serviceSlug,
			standalone: window.opener === null,
			code: route.query.code,
			error: route.query.error,
		}),
	},
	{
		path: '/integration/:serviceSlug/success',
		name: 'IntegrationConnected',
		component: IntegrationConnected,
		props: (route) => ({
			serviceSlug: route.params.serviceSlug,
		}),
	},
	{
		path: '/change-workspace-owner',
		name: 'ChangeWorkspaceOwnerConformation',
		component: ChangeWorkspaceOwnerConformation,
		props(route) {
			return propsValidator(route, ChangeWorkspaceOwnerConformation);
		},
	},
	{
		path: '/delete-workspace',
		name: 'DeleteWorkspaceConformation',
		component: DeleteWorkspaceConformation,
		props(route) {
			return propsValidator(route, DeleteWorkspaceConformation);
		},
	},
	{
		path: '/temporary-verification-code',
		name: 'TemporaryVerificationCode',
		component: TemporaryVerificationCode,
	},
	{
		path: '/pre-connect',
		name: 'PreProfileConnect',
		component: PreProfileConnect,
		props: (route) => ({ redirect: route.query.redirect }),
	},
	{
		path: '/pre-connect-monday',
		name: 'PreProfileConnectMonday',
		component: PreProfileConnectMonday,
		props: (route) => ({ redirect: route.query.redirect }),
	},
	{
		path: '/pre-connect-crisp',
		name: 'PreProfileConnectCrisp',
		component: PreProfileConnectCrisp,
		props: (route) => ({ redirect: route.query.redirect }),
	},
	{
		path: '/app-redirect/:serviceId/',
		name: 'AppGateway',
		component: AppGateway,
		props(route) {
			return propsValidator(route, AppGateway);
		},
	},
	{
		path: '*',
		component: AppLayout,
	},
];

function setRoutesAuthRequirements() {
	const routes = [];
	routes.push(...allowedWithoutAuthRoutes.map((x) => addRequiredAuth(x, false)));
	routes.push(...requiredAuthRoutes.map((x) => addRequiredAuth(x, true)));
	return routes;
}

const router = new VueRouter({
	mode: 'history',
	routes: setRoutesAuthRequirements(),
});

router.beforeEach(Guards.guardLoggedIn);
if (isMobile()) {
	router.beforeEach(Guards.guardMobile);
}

export default router;
